module.exports = __webpack_public_path__ + "static/media/place_sections_generate_in_progress.d31eefff.mov";